import { Builder } from '@builder.io/react';

import HeroCentered from './hero-centered';

Builder.registerComponent(HeroCentered, {
  name: 'HeroCentered',
  inputs: [
    {
      name: "theme",
      type: "string",
      defaultValue: 'dark',
      enum: ['dark', 'light']
    },
    {
      name: "bgAnimated",
      type: "boolean",
      defaultValue: true
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Title'
    },
    {
      name: 'subtitle',
      type: 'string'
    },
    {
      name: 'icon',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
        },
        {
          name: 'alt',
          type: 'string'
        },
        {
          name: 'width',
          type: 'number'
        },
        {
          name: 'height',
          type: 'number'
        }
      ]
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              variant: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary', 'inverted']
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotModal',
          type: 'object',
          showIf: `options.get('hubspotModal')`,
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            }
          ]
        }
      ]
    },
    {
      name: 'img',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'img',
      type: 'object',
      showIf: `options.get('img')`,
      defaultValue:[{
        src: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F9f234cbf261d451fae882a090de10d02',
        alt: 'university-campus'
      }],
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
        },
        {
          name: 'alt',
          type: 'string'
        }
      ]
    },
  ]
});
